"use client";

import { useQueryState } from "nuqs";
import { useCallback } from "react";

export type TabType = "activity" | "processing" | "pending";

export function useDashboardTabs() {
  const [tabQuery, setTabQuery] = useQueryState("tab", {
    defaultValue: "activity",
  });

  const activeTab: TabType =
    tabQuery === "pending"
      ? "pending"
      : tabQuery === "processing"
        ? "processing"
        : "activity";

  const setActiveTab = useCallback(
    (tab: TabType) => {
      setTabQuery(tab);
    },
    [setTabQuery]
  );

  // Back to the default view, with the param REMOVED rather than set to
  // "activity" — the dashboard's bare URL is `/`. Used when the tab stops
  // making sense at all, e.g. the account it belonged to was switched away.
  const resetTab = useCallback(() => {
    setTabQuery(null);
  }, [setTabQuery]);

  return { activeTab, setActiveTab, resetTab };
}
